import { atom } from 'jotai';
export const currentTaskInfoAtom = atom({
  page_id: '',
  page_index: -1,
  page_type: undefined,
  status: undefined,
  task_index: -1,
  task_name: ''
});
export const currentElementInfoAtom = atom({
  elementIndex: -1,
  elementStatus: undefined
});
export const prevScanTimestampAtom = atom(undefined);
export const scanDurationAtom = atom(undefined);
//# sourceMappingURL=bi-atoms.js.map